import type { CatalogProps } from '../index';
import { ProductGrid, Quote, TplFooter, TplHeader, TplRoot } from '../shared';
import { isSectionVisible } from '../sections';
import { Countdown } from '../Countdown';

/** Fast-Commerce Grid — catálogo denso, badges, "adicionar rápido". E-commerce de volume.
 *  Não usa `splitProducts` — esse template não tem seção de "destaque" separada, então um
 *  produto marcado `featured` não pode sumir da grade (só fica em 1º lugar, naturalmente). */
export default function Catalog({ data, apiBase }: CatalogProps) {
  const { store, products } = data;
  const all = isSectionVisible(store, 'grid') ? [...products].sort((a, b) => Number(b.featured) - Number(a.featured)) : [];

  return (
    <TplRoot>
      <div className="bg-[var(--sf-accent,#4edea3)]/15 border-b border-[var(--sf-accent,#4edea3)]/25 text-center py-2 text-sm">
        <span className="font-bold text-[var(--sf-accent,#4edea3)]">Promoção</span> — acaba em <Countdown />
      </div>

      <TplHeader store={store} apiBase={apiBase} suffix=".shop" links={['Novidades', 'Categorias', 'Suporte']} />

      <main className="max-w-6xl mx-auto px-4 py-8 flex flex-col gap-6">
        <h2 className="text-xl font-black tracking-tight">Catálogo</h2>
        <ProductGrid products={all} cols={4} cardCta="Comprar" />
        <Quote store={store} />
      </main>

      <TplFooter store={store} />
    </TplRoot>
  );
}
